import { render } from "./DecessosView.vue?vue&type=template&id=3a5848c4"
import script from "./DecessosView.vue?vue&type=script&lang=js"
export * from "./DecessosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__